import { IAddClient } from "../../interfaces";
import ICMAxios from "../ICMAxios";

const fetchClients = async (userId: any) => {
    const response = await ICMAxios.get(`v1/Client/users/${userId}`);
    return response.data;
}
const addClient =async(formData: IAddClient)=>{
    const response = await ICMAxios.post(`v1/Client`, formData);
    return response.data;
}

const getCountryAndStateData = async ()=>{
    const response = await ICMAxios.get('v1/Client/country');
    return response.data;
}
const clientService = {  fetchClients, addClient, getCountryAndStateData}
export default clientService;